import React from "react";
import { ISelfieQuery } from "~/lib/queries/__generated__/SelfieQuery.generated";
import { IConnectTargetType, IPlanTier } from "~/types/types";
import Feed from "~/components/feed/Feed";
import WriteContentBox from "~/components/feed/WriteContentBox";
import { IVendorQuery } from "~/lib/queries/__generated__/VendorQuery.generated";
import UpgradeAccountBanner from "~/components/vendor/profile/UpgradeAccountBanner";

interface IVendowOwnerFeedTabProps {
  user: ISelfieQuery["selfie"];
  vendor: NonNullable<IVendorQuery["company"]>;
}

export default function VendorOwnerFeedTab({ user, vendor }: IVendowOwnerFeedTabProps) {
  if (vendor.plan.tier === IPlanTier.Basic && vendor.viewerIsMember) {
    return <UpgradeAccountBanner />;
  }

  return (
    <div
      css={{
        display: "grid",
        gridRowGap: 16,
      }}
    >
      <WriteContentBox user={user!} />

      <Feed targetId={vendor._id} targetType={IConnectTargetType.Vendor} />
    </div>
  );
}
